module.exports = __webpack_public_path__ + "img/十二分之五相.c00cb98f.svg";